
import { z } from "zod";

export const ItelDamageExtentValues = ["LESS", "MORE"] as const;
export const ItelDamageExtentSchema = /* @__PURE__ */ z.enum(ItelDamageExtentValues);
export const ItelDamageExtent: (typeof ItelDamageExtentSchema)["enum"] = { "LESS": "LESS", "MORE": "MORE" };
export type ItelDamageExtent = (typeof ItelDamageExtentValues)[number];
